import { useState, useCallback, useEffect } from 'react';

/**
 * Hook for adding missions with auto-scroll and auto-select behavior
 * (No modal - creates directly and scrolls to it)
 */
export function useMissionModal({ onAddTask, _todoModalTriggerRef }) {
  const [pendingMissionId, setPendingMissionId] = useState(null);

  // Handler to create a mission and trigger scroll
  const handleAddMission = useCallback(() => {
    const newTaskId = onAddTask?.(null, null, 'task');
    
    if (newTaskId) {
      setPendingMissionId(newTaskId);
    }
  }, [onAddTask]);

  // Register the trigger function with the parent ref (for toolbar)
  useEffect(() => {
    if (_todoModalTriggerRef) {
      _todoModalTriggerRef.current = handleAddMission;
    }
    return () => {
      if (_todoModalTriggerRef) {
        _todoModalTriggerRef.current = null;
      }
    };
  }, [_todoModalTriggerRef, handleAddMission]);

  // Auto-scroll to newly created mission and trigger edit mode
  useEffect(() => {
    if (!pendingMissionId) return;

    const timeoutId = setTimeout(() => {
      const element = document.querySelector(`[data-todo-id="${pendingMissionId}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        setTimeout(() => {
          const nameSpan = element.querySelector('.todo-item__name');
          if (nameSpan) {
            nameSpan.click();
            
            setTimeout(() => {
              const input = element.querySelector('.todo-item__input');
              if (input) {
                input.select();
              }
            }, 50);
          }
        }, 300);
      }
      
      setPendingMissionId(null);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [pendingMissionId]);

  return {
    handleAddMissionClick: handleAddMission,
  };
}
